export default "__VITE_ASSET__BKi6KLsD__"